import { ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator, MatSort } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { isBefore, isDate, isValid } from 'date-fns';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../services/application/application.service';
import { ErrorService } from '../../services/error/error.service';
import { UserService } from '../../services/user/user.service';
var CollegeStudentSearchComponent = /** @class */ (function () {
    function CollegeStudentSearchComponent(appService, errorService, fb, mediaChange, route, router, userService) {
        this.appService = appService;
        this.errorService = errorService;
        this.fb = fb;
        this.mediaChange = mediaChange;
        this.route = route;
        this.router = router;
        this.userService = userService;
        this._subRelease = new Subject();
        // Class
        this.AllHeaders = ['CollegeStudentID', 'StudentID', 'LastName', 'FirstName', 'MiddleName', 'Grade', 'Actions'];
        this.AvailableSchoolGrades = ['All', '06', '07', '08', '09', '10', '11', '12'];
    }
    CollegeStudentSearchComponent.prototype.ngOnDestroy = function () {
        this._subRelease.next();
        this._subRelease.complete();
    };
    CollegeStudentSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        var self = this;
        self.AvailableSchools = null;
        self.HasAnyUpcoming = false;
        self.PartialViewReady = false;
        self.SearchConducted = false;
        self.SearchResults = null;
        self.SelectedSchoolYear = null;
        self.ShowSearch = true;
        self.LastSizeCode = self.mediaChange.isActive('xs')
            ? 'xs'
            : self.mediaChange.isActive('sm')
                ? 'sm'
                : self.mediaChange.isActive('md')
                    ? 'md'
                    : self.mediaChange.isActive('lg')
                        ? 'lg'
                        : 'xl';
        self.SmallDisplay = self.LastSizeCode === 'xs' || self.LastSizeCode === 'sm';
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
        self.VisibleColumns = self.SearchResults && self.SearchResults.length ? self.VisibleHeaders.slice() : ['NoData'];
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subRelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.LastSizeCode = media.mqAlias;
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.SearchResults && self.SearchResults.length ? self.VisibleHeaders.slice() : ['NoData'];
        });
        self.SearchData = new DataTableSource([], self.paginator, self.sorter, self.SortStudents.bind(self));
        self.SearchForm = self.fb.group({
            FirstName: [''],
            LastName: [''],
            StudentID: [''],
            Grade: [''],
            CollegeID: [null],
            CollegeStudentID: [''],
            Term: [''],
            SchoolNumber: [''],
        }, {
            validator: function (ctrl) {
                if (!ctrl) {
                    return null;
                }
                var form = ctrl.value;
                if (!form.FirstName &&
                    !form.LastName &&
                    !form.StudentID &&
                    !form.Grade &&
                    !form.CollegeID &&
                    !form.CollegeStudentID &&
                    !form.Term &&
                    !form.SchoolNumber) {
                    return { noneprovided: true };
                }
                if (!form.StudentID &&
                    !form.Grade &&
                    !form.CollegeID &&
                    !form.CollegeStudentID &&
                    !form.Term &&
                    !form.SchoolNumber) {
                    // Check to make sure we have at least 5 characters combined from the firstname and lastname fields
                    var fn = (form.FirstName || '').length;
                    var ln = (form.LastName || '').length;
                    if (fn + ln < 5) {
                        return { TooFewCharacters: true };
                    }
                }
                return null;
            },
        });
        // Wait for a first non-null User result before kicking off the page
        self.userService.UserSubject.pipe(takeUntil(self._subRelease), first(function (item) { return item && !!item.AuthToken; })).subscribe(function (_user) {
            self.User = _user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subRelease)).subscribe(function (_u) {
                self.User = _u;
            });
            // Hook into items which can change (such as parameters)
            combineLatest(self.appService.SelectedSchoolYearSubject, self.appService.GetAllSchools(self.User.AuthToken), function (selYear, schools) {
                return {
                    SelectedYear: selYear,
                    Schools: schools,
                };
            })
                .pipe(takeUntil(self._subRelease))
                .subscribe(function (packet) {
                self.SelectedSchoolYear = packet.SelectedYear;
                self.AvailableSchools = packet.Schools;
                // If this college person only has one possible college to search over, preselect it.
                if (self.User && self.User.StaffColleges && self.User.StaffColleges.length === 1) {
                    self.SearchForm.patchValue({
                        CollegeID: self.User.StaffColleges[0].CollegeID,
                    });
                }
                _this.firstinput.nativeElement.focus();
                // Set the page as ready
                self.PartialViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    // #region Clear Form Method
    CollegeStudentSearchComponent.prototype.ClearForm = function () {
        this.SearchForm.reset();
        this.firstinput.nativeElement.focus();
    };
    // #endregion
    // #region Handle Search Method
    CollegeStudentSearchComponent.prototype.HandleSearch = function () {
        var self = this;
        // If the college choice is -1 (All), null it out before continuing to the search.
        var searchParams = self.SearchForm.value;
        if (searchParams.CollegeID === -1) {
            searchParams.CollegeID = null;
        }
        // Call to get the search results ('0937' - test school)
        self.appService
            .SearchForCollegeStudent(self.User.AuthToken, self.SelectedSchoolYear, searchParams.StudentID, searchParams.CollegeID, searchParams.CollegeStudentID, searchParams.Term, self.SelectedSchoolYear, searchParams.Grade, searchParams.FirstName, searchParams.LastName, searchParams.SchoolNumber)
            .subscribe(function (results) {
            self.SearchResults = results;
            if (self.SmallDisplay) {
                self.ShowSearch = false;
            }
            if (self.SearchResults && self.SearchResults.length) {
                self.VisibleColumns = self.VisibleHeaders.slice();
            }
            else {
                self.VisibleColumns = ['NoData'];
            }
            self.SearchData.Update(self.SearchResults);
            self.SearchConducted = true;
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    // #endregion
    // #region Show Search Form Method
    CollegeStudentSearchComponent.prototype.ShowSearchForm = function () {
        this.ShowSearch = true;
        this.SearchConducted = false;
    };
    // #endregion
    // #region Sort Students Method
    CollegeStudentSearchComponent.prototype.SortStudents = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'CollegeStudentID':
                _a = [First.CollegeStudentID, Second.CollegeStudentID], PropA = _a[0], PropB = _a[1];
                break;
            case 'StudentID':
                _b = [First.StudentID, Second.StudentID], PropA = _b[0], PropB = _b[1];
                break;
            case 'LastName':
                _c = [First.LastName, Second.LastName], PropA = _c[0], PropB = _c[1];
                break;
            case 'FirstName':
                _d = [First.FirstName, Second.FirstName], PropA = _d[0], PropB = _d[1];
                break;
            case 'MiddleName':
                _e = [First.MiddleName, Second.MiddleName], PropA = _e[0], PropB = _e[1];
                break;
            case 'Grade':
                _f = [First.GradeLevel, Second.GradeLevel], PropA = _f[0], PropB = _f[1];
                break;
        }
        if (isDate(PropA)) {
            if (!isDate(PropB)) {
                return 0;
            }
            if (!isValid(PropA) || !isValid(PropB)) {
                return 0;
            }
            if (isBefore(PropA, PropB)) {
                return -1 * (self.sorter.direction === 'asc' ? 1 : -1);
            }
            if (isBefore(PropB, PropA)) {
                return 1 * (self.sorter.direction === 'asc' ? 1 : -1);
            }
            return 0;
        }
        else {
            var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
            var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
            return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        }
        var _a, _b, _c, _d, _e, _f;
    };
    // #endregion
    // #region View Student Method
    CollegeStudentSearchComponent.prototype.ViewStudent = function (student) {
        if (!student) {
            return;
        }
        // Route to the student view
        this.router.navigate(['/studentview', student.StudentID]);
    };
    return CollegeStudentSearchComponent;
}());
export { CollegeStudentSearchComponent };
// #region Custom Classes
// #region Search Result Class
var SearchResult = /** @class */ (function () {
    function SearchResult() {
    }
    return SearchResult;
}());
export { SearchResult };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/app/collegestudentsearch/collegestudentsearch.component.ts.pre-build-optimizer.js